import { motion } from "framer-motion";
import Seo from "@/components/Seo";
import { ServicesEditorial } from "@/components/site/ServicesEditorial";
import { CtaBand } from "@/components/site/CtaBand";

export default function ServicesPage() {
    return (
        <motion.main
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
        >
            <Seo
                title="Usluge | Ramljak Auto Detailing Centar Ljubuški"
                siteName="Ramljak Auto Detailing Centar"
                description="Dubinsko čišćenje interijera, poliranje, auto detailing i održavanje vozila u Ljubuškom. Pogledajte sve usluge i zakažite termin."
            />
            <div className="pt-20 md:pt-24">
                <ServicesEditorial />
            </div>
            <CtaBand />
        </motion.main>
    );
}
